import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { CreateSessionDto, PublicSession } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const createSession = async (
  orgId: string,
  session: CreateSessionDto,
): Promise<PublicSession> => {
  const response = await axiosClient.post(`/${orgId}/sessions`, {
    ...session,
    guests: session.guests?.map((guest) => guest.toLowerCase().trim()),
  });
  return response.data;
};

function useCreateSession(
  mutationOptions?: Partial<
    UseMutationOptions<PublicSession, HttpError, CreateSessionDto>
  >,
) {
  const { organisation } = useOrganisation();
  return useMutation({
    mutationFn: (session) => createSession(organisation.id, session),
    ...mutationOptions,
  });
}

export { useCreateSession };
